import { Badge, Flex, useAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { fetchUserAttributes, FetchUserAttributesOutput } from 'aws-amplify/auth';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MdMenu } from 'react-icons/md';

function MapUserIcon({ onClick }: { onClick: () => void }) {

    const { user } = useAuthenticator(context => [context.user]);

    const { t } = useTranslation();

    const [userAttributes, setUserAttributes] = useState<FetchUserAttributesOutput>()

    useEffect(() => {

        if (user) {
            const setUser = async () => {
                try {
                    const currentUserAttributes: FetchUserAttributesOutput = await fetchUserAttributes()

                    setUserAttributes(currentUserAttributes)
                } catch (error) {
                    setUserAttributes(undefined)
                }
            }

            setUser()
        } else {
            setUserAttributes(undefined)

        }
    }, [user]);


    return (
        <>
            <Flex
                direction='row'
                className='user-flex'
            >
                {/* TODO use username/photo in future. Load user details in useEffect(), pass user into effect deps */}
                {/* <Avatar
                    colorTheme='info'
                    className='user-icon'
                    onClick={onClick}
                >
                    {user?.signInDetails?.loginId ? user.signInDetails.loginId[0] : '#'}
                </Avatar>
                 */}

                <Badge
                    size="large"
                    className='user-icon'
                    variation={user ? "success" : "warning"}
                    whiteSpace="nowrap"
                    onClick={onClick}
                >
                    <Flex direction="row" gap="xs" alignItems="center">
                        {userAttributes ? userAttributes.nickname : t('user.sign-in')}
                        <MdMenu />
                    </Flex>
                </Badge>
            </Flex >

        </>
    )
}
export default MapUserIcon;